module.exports = __webpack_public_path__ + "img/66.c1a63981.jpg";